import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-white py-16 text-center border-t border-brand-muted/30">
      <div className="max-w-4xl mx-auto px-4">
        <h4 className="font-serif text-3xl text-brand-dark tracking-tighter mb-6">
          J <span className="text-brand-accent italic font-light">&</span> B
        </h4>
        <p className="text-[10px] tracking-[0.5em] uppercase text-brand-dark/50 mb-8">
          Cartagena, Colombia • 27.07.2027
        </p>
      </div>
    </footer>
  );
}